import React, { useState, useEffect } from 'react';
import { UrlDev as Url } from '../../../url';
import '../../../entrydoor.css';
import './DoorLiteItems.css';

// Fetches glass/lite items filtered by collection and size.
// Calls onChange(item | null) whenever selection changes.

const DoorLiteItems = ({
    value        = null,
    onChange,
    selectedCollection = '',
    selectedSize = '',
    searchByName = '',
    label        = 'Door Lites',
}) => {
    const [items, setItems]         = useState([]);
    const [selected, setSelected]   = useState(value);

    useEffect(() => {
        if (!selectedCollection && !selectedSize) { setItems([]); return; }

        const params = new URLSearchParams();
        if (selectedCollection) params.append('collection', selectedCollection);
        if (selectedSize)       params.append('size', selectedSize);

        fetch(`${Url}/doorlites?${params.toString()}`)
            .then((r) => r.json())
            .then((data) => {
                let list = Array.isArray(data) ? data : [];
                if (searchByName) {
                    list = list.filter((i) =>
                        i.value.toLowerCase().includes(searchByName.toLowerCase())
                    );
                }
                setItems(list);
                // keep selection only if still in the list
                setSelected((prev) => list.find((i) => i.id === prev?.id) ? prev : null);
            })
            .catch((err) => {
                console.error('DoorLiteItems fetch error:', err);
                setItems([]);
            });
    }, [selectedCollection, selectedSize, searchByName]);

    // bubble up when selection changes
    useEffect(() => { onChange(selected); }, [selected]);

    const handleSelect = (item) => {
        setSelected((prev) => prev?.id === item.id ? null : item);
    };

    return (
        <div className="a-container">
            <label>{label}</label>
            <div className="door-items-container">
                {items.length > 0 ? (
                    items.map((item) => (
                        <div
                            key={item.id}
                            className={`door-item${selected?.id === item.id ? ' selected' : ''}`}
                            onClick={() => handleSelect(item)}
                            style={{
                                cursor: 'pointer',
                                textAlign: 'center',
                                width: '120px',
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                justifyContent: 'flex-start',
                            }}
                        >
                            <img
                                src={`/images/${item.image}`}
                                alt={item.value}
                                style={{ maxHeight: '100px', width: 'auto' }}
                            />
                            <p style={{
                                fontWeight: selected?.id === item.id ? 'bold' : 'normal',
                                whiteSpace: 'normal',
                                wordWrap: 'break-word',
                                overflowWrap: 'break-word',
                                textAlign: 'center',
                                lineHeight: '1.2',
                                margin: '5px 0',
                            }}>
                                {item.value}
                            </p>
                        </div>
                    ))
                ) : (
                    <p>No door lites available.</p>
                )}
            </div>
        </div>
    );
};

export default DoorLiteItems;
